import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Space, Table } from "antd";
import { ClientPricelist, Pricelist } from "@/root/models/pricelist";
import useClientPricelists from "@/hooks/useClientPricelists";
import PrintPricelist from "../PrintPricelist";
import useModalOpen from "@/hooks/useModalOpen";
import { GrDocument, GrDocumentVerified } from "react-icons/gr";
import ClientPricelistTableActions from "./components/ClientPricelistTableActions";
import CreatePricelist from "./components/CreatePricelist";
import ActivePricelist from "./components/ActivePricelist";

const ClientPricelists = () => {
  const { t } = useTranslation();
  const {
    pricelists,
    getPricelistsLoading,
    createPricelist,
    deletePricelist,
    editPricelist,
  } = useClientPricelists();
  const [activePricelist, setActivePricelist] = useState<ClientPricelist>();

  const { modal, onHandleCancel, onEditSuccess, isModalOpen } = useModalOpen();

  const pricelistsColumn = [
    {
      width: 60,
      dataIndex: "applied",
      key: "applied",
      render: (applied: Pricelist["applied"]) => (
        <div style={{ paddingLeft: 10, paddingTop: 5 }}>
          {applied ? (
            <GrDocumentVerified size={18} />
          ) : (
            <GrDocument size={18} />
          )}
        </div>
      ),
    },
    {
      title: t("Номер"),
      dataIndex: "number",
      key: "number",
    },
    {
      title: t("Дата"),
      dataIndex: "date",
      key: "date",
    },
    {
      title: t("Дата активації"),
      dataIndex: "activationDate",
      key: "activationDate",
    },
    {
      title: t("Контрагент"),
      dataIndex: "client",
      key: "client",
      render: (client: ClientPricelist["client"]) => <span>{client.name}</span>,
    },
    {
      title: t("Тип"),
      dataIndex: "pricelistType",
      key: "pricelistType",
      render: (type: Pricelist.Type) => <span>{type.name}</span>,
    },
    {
      title: t("Опис"),
      dataIndex: "description",
      key: "description",
    },
    {
      title: "",
      key: "action",
      render: (_: any, pricelist: ClientPricelist) => (
        <ClientPricelistTableActions
          pricelist={pricelist}
          onDelete={deletePricelist}
          onEdit={editPricelist}
          onEditSuccess={onEditSuccess}
          modal={modal}
          onCancel={onHandleCancel}
          onModalOpen={() => {
            isModalOpen(pricelist.clientsPricelistUUID);
          }}
        />
      ),
    },
  ];

  return (
    <Space direction="vertical">
      <Space>
        <CreatePricelist onCreate={createPricelist} />
        <Button disabled={!activePricelist} onClick={() => window.print()}>
          {t("Друк")}
        </Button>
      </Space>
      {activePricelist && <PrintPricelist pricelist={activePricelist} />}
      <div style={{ display: "flex", gap: 10 }}>
        <Table
          style={{ userSelect: "none" }}
          columns={pricelistsColumn}
          dataSource={pricelists.map((p) => ({
            ...p,
            key: p.clientsPricelistUUID,
          }))}
          pagination={false}
          expandedRowKeys={pricelists.map((p) => p.clientsPricelistUUID)}
          expandRowByClick
          loading={getPricelistsLoading}
          onRow={(pricelist) => ({
            onClick: () => setActivePricelist(pricelist),
            onDoubleClick: () => isModalOpen(pricelist.clientsPricelistUUID),
          })}
        />
        {activePricelist && (
          <ActivePricelist pricelist={activePricelist} presentation />
        )}
      </div>
    </Space>
  );
};

export default ClientPricelists;
